// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"Gx-z","expressButtonContainerWithPayPal":"Hx-z","expressButton":"Ix-z","or":"Jx-z"};